export default __webpack_public_path__ + "static/media/Urgency_immediate.54722043.svg";